module.exports = __webpack_public_path__ + "img/section3Card1logo2.36b1bf4e.png";